<template>
  <div class="sscontainer-footer-footer reseaux-sociaux">
    <ul class="menu-picto-footer">
      <li class="facebook"><a href="https://www.facebook.com/coolocblog/" target="_blank"
                              title="Découvrir la page Facebook de COOLOC"><span
        class="invisible">Page Facebook de COOLOC</span></a></li>
      <li class="instagram"><a href="https://www.instagram.com/cooloc/" target="_blank"
                               title="Découvrir la page Instagram de COOLOC"><span
        class="invisible">Page Instagram de COOLOC</span></a></li>
      <!--li class="twitter"><a href="#"
                             title="Découvrir le compte Twitter de COOLOC"><span
        class="invisible">Compte Twitter de COOLOC</span></a></li-->
      <!--li class="pinterest"><a href="#"
                               title="Découvrir la page Pinterest de COOLOC"><span
        class="invisible">Page Pinterest de COOLOC</span></a></li-->
    </ul>
    <div class="mobile-only logo-footer">
      <router-link :to="coolocBaseURL" title="Retour à la page d'accueil">
        <img
          src="/static/images/logo-cooloc.png" alt="Logo COOLOC" width="190" height="40"
          id="logo" class="svg"/>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'footer-menus-socials',
  computed: {
    coolocBaseURL() { return process.env.VUE_APP_COOLOC_BASE_URL },
  },
}
</script>
